export const StatusDot = ({ status }: { status: string }) => (
  <span
    className={`enb-status-dot ${status === "Enabled" ? "enb-dot--green" : "enb-dot--red"}`}
  />
);